import request from '@/utils/request';
import { host, newHost } from '@/global-config';

// copilot begin
// 封装请求函数，减少重复代码
const requestWrapper = (url, method, data = {}, params = {}, responseType = null, header = {}) => request({
  url,
  method,
  data,
  params,
  baseURL: newHost,
  responseType,
  header,
});

// 封装使用host的请求函数，用于安全密码设置相关接口
const requestWrapperWithHost = (url, method, data = {}, params = {}, responseType = null, header = {}) => request({
  url,
  method,
  data,
  params,
  baseURL: host,
  responseType,
  header,
});

// 分页查询分帐方绑定接收方
export const queryListReceiverBind = data => requestWrapper('/shareAccount/listReceiverBind', 'post', data);

// 下载分帐方绑定接收方文件
export const exportReceiverBind = data => requestWrapper('/shareAccount/exportReceiverBind', 'post', data, {}, 'blob');

// 分页查询分账方提现明细
export const queryListWithdrawRecords = data => requestWrapper('/shareAccount/listWithdrawRecords', 'post', data);

// 分账方提现明细异步导出
export const exportListWithdrawRecords = data => requestWrapper('/withdraw/download', 'post', data);

// 查询分账方分账记录
export const queryPageSplitSerial = data => requestWrapper('/transaction/pageSplitSerial', 'post', data);

// 分账方分账明细异步导出
export const exportPageSplitSerial = data => requestWrapper('/shareAccountRecord/download', 'post', data);

// 下载同个批次的明细
export const exportSaDetailByBatch = data => requestWrapper('/shareAccount/exportSaDetailByBatch', 'post', data, {}, 'blob');

// 查询商户资金账户开通结果
export const stateQuery = params => requestWrapper('/shareAccount/stateQuery', 'get', {}, params);

// 分账方余额查询
export const accountSearchSubBalance = data => requestWrapper('/transaction/accountSearchSubBalance', 'post', data);

// 账方余额流水记录
export const searchBalanceFlow = data => requestWrapper('/transaction/searchBalanceFlow', 'post', data);

// 账方余额流水详情
export const searchBalanceFlowDetail = data => requestWrapper('/transaction/searchBalanceFlowDetail', 'post', data);

// 分账方余额流水明细异步导出
export const exportBalanceFlow = data => requestWrapper('/balance/download', 'post', data);

// 提现预查询
export const queryWithdrawalInfo = data => requestWrapper('/shareAccount/withdrawal/info', 'post', data);

// 提现提交
export const submitWithdrawalInfo = data => requestWrapper('/shareAccount/submitWithdrawApply', 'post', data);

// 上传分账文件
export const importSaPlan = data => requestWrapper('/shareAccount/importSaPlan', 'post', data, {}, null, { 'content-type': 'multipart/form-data' });

// 下载分账计划模板Excel模板
export const downloadSaPlan = params => requestWrapper('/shareAccount/downloadSaPlan', 'get', {}, params, 'blob');

// 分账申请
export const applySplitAccount = data => requestWrapper('/transaction/applySplitAccount', 'post', data);

// 下载分账计划异常原因文件
export const exportSaPlanException = data => requestWrapper('/shareAccount/exportSaPlanException', 'post', data, {}, 'blob');

// 生成接收方开通的H5链接和token
export const getReceiveToken = data => requestWrapper('/shareAccount/getReceiveToken', 'post', data);

// 获取分账方开户链接
export const getSplitToken = data => requestWrapper('/shareAccount/getSplitToken', 'post', data);

// 分账确认
export const executeSplitAccount = data => requestWrapper('/transaction/executeSplitAccount', 'post', data);

// 充值记录列表
export const queryRechargeRecordList = data => requestWrapper('/cfs/recharge-record/list', 'post', data);

// 充值记录详情
export const queryRechargeRecordDetail = data => requestWrapper('/cfs/recharge-record/detail', 'post', data);

// 商户CFS服务账号信息（取手机号用）
export const queryCfsAccountInfo = params => requestWrapper('/cfs/account/info', 'get', {}, params);

// 代付验证码发送
export const sendVerifyCode = params => requestWrapper('/cfs/pay/sendVerifyCode', 'get', {}, params);

// 提交代付申请
export const commitCfsAccountInfo = data => requestWrapper('/cfs/pay/commit', 'post', data);

// 代付记录列表
export const queryPayRecordList = data => requestWrapper('/cfs/pay-record/list', 'post', data);

// 云管家服务权限
export const getAuthorityServer = params => requestWrapper('/cm-server/authority/get', 'get', {}, params);

// 安全设置-密码验证查询
export const getSecurityConfigStatus = params => requestWrapperWithHost('/accountSecurityConfig/getStatus', 'get', {}, params);

// 安全设置-发送验证码
export const sendSecurityVerifyCode = () => requestWrapperWithHost('/accountSecurityConfig/sendVertifyCode', 'get');

// 安全设置-校验验证码
export const checkSecurityVerifyCode = params => requestWrapperWithHost('/accountSecurityConfig/checkVertifyCode', 'get', {}, params);

// 安全设置-密码验证状态切换
export const updateSecurityStatus = data => requestWrapperWithHost('/accountSecurityConfig/updateStatus', 'post', data);
// copilot end
